// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__31GMN","head":"ProcedureTableInfo_head__2gLfY"};